export default __webpack_public_path__ + "static/media/pl.a7dc274e.svg";